import React, { useState, useEffect } from 'react';
import Button from './Button';
import { useTranslation, Trans } from 'react-i18next';

const CookieConsentBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (consent === null) {
      // Only show the banner if no choice has been made
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'true');
    setIsVisible(false);
    // Here you could initialize analytics scripts if needed, e.g., window.initAnalytics();
  };

  const handleDecline = () => {
    localStorage.setItem('cookie_consent', 'false');
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-slate-800/95 backdrop-blur-sm text-white p-4 z-[60] shadow-lg animate-fadeInUp">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-sm text-slate-300 flex-grow text-center md:text-left">
          <Trans i18nKey="cookieConsentBanner.message">
            Koristimo kolačiće kako bismo poboljšali vaše iskustvo. Nastavkom korišćenja sajta, prihvatate našu
            <a href={t('helperMenu.privacyPolicyLink')} target='_blank' className="underline hover:text-white font-semibold">
              Politiku privatnosti
            </a>.
          </Trans>
        </p>
        <div className="flex-shrink-0 flex gap-4">
          <Button onClick={handleDecline} variant="secondary" size="sm" className="!bg-slate-600 !text-white hover:!bg-slate-500">{t('cookieConsentBanner.decline')}</Button>
          <Button onClick={handleAccept} variant="primary" size="sm">{t('cookieConsentBanner.accept')}</Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;